"use client";

import { motion } from "framer-motion";
import { outcomes, whyUs } from "@/lib/data/site";
import { SectionHeader } from "@/components/ui/section-header";

export function Outcomes() {
  return (
    <section className="relative py-16 sm:py-24 md:py-32">
      <div className="container-wide">
        <SectionHeader
          eyebrow="Business Outcomes"
          title={"WE ENGINEER\nBUSINESS OUTCOMES."}
          description="Technology only matters when it changes how the enterprise operates, decides, and competes."
        />
        <div className="mt-10 grid gap-4 sm:mt-14 sm:grid-cols-2 lg:grid-cols-3">
          {outcomes.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="rounded-[1.5rem] border border-border p-6"
            >
              <p className="font-mono text-xs text-accent">0{index + 1}</p>
              <h3 className="mt-3 font-display text-2xl tracking-tight">{item.title}</h3>
              <p className="mt-3 text-sm text-muted leading-relaxed">{item.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function WhyUs() {
  return (
    <section className="relative overflow-hidden py-16 sm:py-24 md:py-32">
      <div className="absolute inset-0 bg-gradient-to-r from-accent/5 via-transparent to-cyan/5" />
      <div className="container-wide relative">
        <SectionHeader
          eyebrow="Why Maxridge"
          title={"WHY COMPANIES\nBUILD WITH US"}
          description="A partnership model built for AI-first ambition with engineering seriousness."
        />
        <div className="mt-10 relative sm:mt-14">
          <div className="absolute left-[18px] top-0 bottom-0 w-px bg-gradient-to-b from-accent via-violet to-cyan md:left-1/2" />
          <div className="space-y-8">
            {whyUs.map((item, index) => (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                className={`relative grid gap-4 md:grid-cols-2 ${index % 2 === 1 ? "md:text-right" : ""}`}
              >
                <div className={index % 2 === 1 ? "md:col-start-2" : ""}>
                  <div className="inline-flex items-center gap-3">
                    <span className="relative z-10 h-9 w-9 rounded-full border border-accent bg-background text-center text-xs leading-9 text-accent">
                      0{index + 1}
                    </span>
                    <h3 className="font-display text-2xl tracking-tight md:text-3xl">{item.title}</h3>
                  </div>
                  <p className="mt-3 max-w-md text-sm text-muted leading-relaxed md:ml-12">
                    {item.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
